export const MOST_POPULAR = { name: 'Professional', billingCycleValue: 1 }

export const SUBSCRIPTION_TABS = { subscription: 'subscription', billingHistory: 'billing-history' }

export const BILLING_CYCLE = { month: 1, year: 12, infinite: -1 }

export const BILLING_CYCLE_TYPE = { year: 'YEAR', month: 'MONTH', day: 'DAY' }

export const BILLING_PERIOD = { month: 'month', annual: 'annual' }

export const ORDER_STATUSES = ['PENDING_APPROVAL', 'PAYMENT_AUTHORIZED', 'COMPLETE']

export const PRODUCT_ACTIONS = { notAvailable: 'notavailable', downgrade: 'downgrade' }

export const PAYMENT_METHOD_CODES = { FREE: 'FREE' }
